import { Box, Grid, Typography } from "@material-ui/core"
import { ItemsModel } from "../../../../../../../../model/api/pedidos/itens-model"
import { useStyles } from "./card-produto-pedido-styles"
import classNames from "classnames"

export interface CardProdutoPedidoProps {
    produto: ItemsModel
    isSubItem?: boolean
}

export const CardProdutoPedido = ({ produto, isSubItem = false }: CardProdutoPedidoProps) => {

    const classes = useStyles()

    return (
        <Box className={classNames(isSubItem ? classes.subItem : classes.card)}>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <Typography className={classes.titleProdutoPedido}>{produto.descricao}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography className={classes.titleProdutoPedido}>{produto.quantidade} <Box component="span" fontSize="12px">UN</Box></Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography className={classes.titleProdutoPedido}>{produto.valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Typography>
                </Grid>
                {produto.subItens && produto.subItens.length > 0 && (
                    <Grid item xs={12}>
                        <Box ml={2}>
                            {produto.subItens.map(subItem => (
                                <CardProdutoPedido
                                    key={subItem.id}
                                    produto={subItem}
                                    isSubItem={true}
                                />
                            ))}
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}